import wx from 'weixin-js-sdk';
import axios from 'axios';

const debug = window.location.href.includes('//192.168.') || window.location.href.includes('//localhost:') || window.location.href.includes('//127.0.0.1:');
//const debug = false;
const signaturedUrls = new Set();
let firstUrl = window.location.href.split('#')[0];

// 模拟微信SDK
const mockWX = {
  config : config => {
    console.log("wecat sdk - config: ",  config);
  },
  scanQRCode: function(cfg) {
    var str = prompt('模拟微信扫一扫\n输入模拟扫描到的内容', 'http://weixin.qq.com/q/n0xlI_XmwZm4Jb9hP2TJ');
    if (str) cfg.success({ resultStr: str });
    else {
        if (cfg.cancel) cfg.cancel();
        if (cfg.fail) cfg.fail();
    }
    if (cfg.complete) cfg.complete();
  },
  ready : callback => callback(mockWX),
  chooseWXPay: function(cfg) {
    const ok = confirm('模拟支付完成或取消');
    const r = { errMsg: ok ? 'chooseWXPay:ok' : 'chooseWXPay:fail' };
    setTimeout(function() {
        if (ok) {
            cfg.success(r);
        } else {
            if (cfg.cancel) cfg.cancel();
            if (cfg.fail) cfg.fail();
        }
        if (cfg.complete) cfg.complete(r);
    }, 1000);
},
  error : ()=>{},
  closeWindow : ()=> console.log("wecat sdk - close window"),
  chooseImage : ({success}) => success({localIds:['wxResource://fj9348r']}),
  getLocalImgData : ({success}) => success({localData: 'R0lGODlhAQABAIAAAAUEBAAAACwAAAAAAQABAAACAkQBADs='}),
  miniProgram : {
    getEnv: (func) => func({miniprogram : false})
  }
}

const setFirstUrl = url => firstUrl = url;

const WechatPlugin = {
  install : function(Vue) {
    Vue.prototype.$wechat = {
      sdk: (callback) => {
        const wechat = debug ? mockWX : wx;
        const currentUrl = window.__wxjs_is_wkwebview ? firstUrl : window.location.href.split('#')[0];
        if (signaturedUrls.has(currentUrl)) {
          return callback ? callback(wechat) : undefined;
        }
        else {
          axios.post('/json/wechat/signature', {url: currentUrl}).then(resp => {
              if (resp.data) {
                const config = {
                  ...resp.data, 
                  debug: false, 
                  jsApiList : ['scanQRCode', 'hideOptionMenu', 'closeWindow', 'onMenuShareAppMessage', 'chooseImage', 'uploadImage', 'downloadImage', 'getLocalImgData'],
                  openTagList: ['wx-open-subscribe']
                }
                wechat.config(config);
                wechat.ready(()=>{
                  signaturedUrls.add(currentUrl);
                  if (callback) {
                    callback(wechat);
                  }
                  
                });
                wechat.error(res => console.log(res));
              }
            }
          )
        }
      }
    }
  }
}

export default WechatPlugin;
export {setFirstUrl}